import { restClient } from '@/Core'

import { CRM_DOCUMENT_FILE_FIELDS } from './CrmDocument'

/** Те, що задача бере з `formContext` картки документа. */
export interface CrmDocumentFilesFormContext {
    values?: { uuid?: unknown }
    setInitialValue?: (path: string, value: unknown) => void
    setValue?: (path: string, value: unknown) => void
}

/**
 * Перечитує файли документа після завантаження чи видалення (`SPEC-008`
 * §5.7.1): Word тягне за собою PDF — бек перегенеровує його з нового Word, а
 * ядровий `FileInput` знає лише про файл, який сам завантажив.
 *
 * Оновлює **лише** `wordFile` і `pdfFile`: перечитати всю картку означало б
 * затерти номер чи дату, які людина саме правила, але ще не зберегла.
 *
 * `forceRefresh`: ядровий клієнт дедуплікує GET на 30 с.
 */
export const ReloadCrmDocumentFilesTask = async (
    restUrl: string,
    formContext: CrmDocumentFilesFormContext | undefined
): Promise<void> => {
    const uuid = formContext?.values?.uuid

    if (typeof uuid !== 'string' || uuid === '') return

    const raw = await restClient.get(`${restUrl}/${encodeURIComponent(uuid)}?permissions=true`, undefined, {
        forceRefresh: true,
    })
    const fresh = (raw ?? {}) as unknown as Record<string, unknown>

    for (const field of CRM_DOCUMENT_FILE_FIELDS) {
        const value = fresh[field] ?? null

        formContext?.setInitialValue?.(field, value)
        formContext?.setValue?.(field, value)
    }
}
